function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoalCarousel = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _Carousel = require("../Carousel");
var _styles = require("../../styles");
var _styles2 = require("./styles");
var _reactI18next = require("react-i18next");
var _useLang = require("./useLang");
var _Button = require("../Button");
var _utils = require("../../utils");
var _Heading = require("../Heading");
var _IntroText = require("../IntroText");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["Image", "items", "ItemTemplate", "isOverflowVisible", "style"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var GoalCarousel = exports.GoalCarousel = (0, _react.memo)(function (_ref) {
  var Image = _ref.Image,
    items = _ref.items,
    ItemTemplate = _ref.ItemTemplate,
    _ref$isOverflowVisibl = _ref.isOverflowVisible,
    isOverflowVisible = _ref$isOverflowVisibl === void 0 ? true : _ref$isOverflowVisibl,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useStyles = (0, _styles2.useStyles)(),
    styles = _useStyles.styles;
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useContext = (0, _react.useContext)(_utils.LinkContext),
    goalsPageLinkUrl = _useContext.goalsPageLinkUrl;
  var _key = (0, _react.useMemo)(function () {
    return items == null ? void 0 : items.map(function (i) {
      return i.id;
    }).join('_');
  }, [items]);
  return (0, _jsxRuntime.jsxs)(_reactNative.View, Object.assign({
    testID: "GoalCarousel",
    style: [styles.container, style]
  }, props, {
    children: [(0, _jsxRuntime.jsx)(_Heading.Heading, {
      level: 2,
      style: styles.heading,
      children: t('goalCarousel:heading')
    }), (0, _jsxRuntime.jsx)(_IntroText.IntroText, {
      style: styles.intro,
      children: t('goalCarousel:intro')
    }), (0, _jsxRuntime.jsx)(_Carousel.Carousel, {
      isOverflowVisible: isOverflowVisible,
      maxItemWidth: (0, _styles.getREM)(19),
      Image: Image,
      children: items.map(function (item, index) {
        return (0, _jsxRuntime.jsx)(ItemTemplate, {
          item: item,
          style: {
            marginVertical: (0, _styles.getREM)(0.5)
          }
        }, "GoalCarousel-".concat(_key, "_").concat(item.id, "_").concat(index));
      })
    }, _key), (0, _jsxRuntime.jsx)(_Button.Button, {
      type: _Button.ButtonType.brand,
      href: goalsPageLinkUrl,
      label: t('goalCarousel:button'),
      containerStyle: styles.link,
      testID: "GoalCarouselButton"
    })]
  }));
});